// removed by extract-text-webpack-plugin
module.exports = {"property-editor":"property-editor__property-editor___22SBl"};